/** Display helpers for the signed-in admin user (header, settings summary). */

export function getAvatarUrl(user) {
  return String(
    user?.avatarUrl ?? user?.image ?? user?.profileImageUrl ?? user?.profileImage ?? ""
  ).trim();
}

export function getProfileNames(user) {
  const firstName = String(user?.firstName ?? "").trim();
  const lastName = String(user?.lastName ?? "").trim();
  if (firstName || lastName) {
    return { firstName, lastName };
  }
  const name = String(user?.name ?? "").trim();
  if (!name) return { firstName: "", lastName: "" };
  const parts = name.split(/\s+/).filter(Boolean);
  return {
    firstName: parts[0] || "",
    lastName: parts.slice(1).join(" ") || "",
  };
}

export function getDisplayName(user) {
  const { firstName, lastName } = getProfileNames(user);
  const full = [firstName, lastName].filter(Boolean).join(" ").trim();
  return full || String(user?.name ?? "").trim() || "Admin";
}

export function getInitials(user) {
  const { firstName, lastName } = getProfileNames(user);
  if (firstName && lastName) {
    return `${firstName[0] || ""}${lastName[0] || ""}`.toUpperCase();
  }
  const name = String(user?.name ?? firstName ?? "").trim();
  if (!name) return "A";
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  }
  return (parts[0]?.[0] || "A").toUpperCase();
}
